import React, { useEffect, useState } from 'react';
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import Col from "@visa/vds/col";
import Typography from "@visa/vds/typography";
import MCSOverlayLoading from '../../../components/MCSOverlayLoading';
import { GlobalAlertContext } from "../../../context/GlobalAlertContext";
import { AuthContext, useAuthContextUser } from "../../../context/AuthContext";
import { EmailNotificationApi } from "../../../services/emailNotification.service";
import ButtonGroup from '@visa/vds/button-group';
import ButtonText from '@visa/vds/button-text';
import ServiceAccordion from "./ServiceAccordion";


const UserEmailNotification = () => {
    const { promiseInProgress } = usePromiseTracker();
    const user = useAuthContextUser();
    const [serviceData, setServiceData] = useState(null);

    const fetchData = async (alertObj) => {
        trackPromise(
            EmailNotificationApi.GetEmailNotificationUsersByService()
                 .then((result) => {
                    var data = result.data;
                    setServiceData(data);
                })
                .catch((error) => {
                    if (alertObj) alertObj.setErrorMessage(error.message);
                })
        );
    };

    const updateEmailNotificationUserFrequencies = async (alertObj) => {
        trackPromise(
            EmailNotificationApi.UpdateEmailNotificationUserFrequencies(serviceData)
                .then((response) => {
                    if (!response.data) {
                        alertObj.setErrorMessage("Failed to updated.")
                    } else {
                        alertObj.setSuccessMessage("Successfully updated")
                    }
                })
                .catch((error) => {
                    alertObj.setErrorMessage('An error occured while udpating email notification user frequencies : ' + error.message);
                })
        );
    }
    useEffect(() => {
        fetchData();
    }, []);

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
            <AuthContext.Consumer>
                {(currentUser) => (
                    <GlobalAlertContext.Consumer>
                        {(alertObj) => (
                            <>
                                <Grid>
                                    <Row>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <Typography tag="h1">Email Notification</Typography>
                                                </Col>
                                            </Row>
                                            <ServiceAccordion setServiceData={setServiceData} serviceData={serviceData} alertObj={alertObj}/>
                                            <Row>
                                                <Col>
                                                    <ButtonGroup direction="right">
                                                        <ButtonText onClick={() => updateEmailNotificationUserFrequencies(alertObj)} colorScheme="primary" >Save Changes</ButtonText>
                                                    </ButtonGroup>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </Grid>
                            </>
                        )}
                    </GlobalAlertContext.Consumer>
                )}
            </AuthContext.Consumer>
        </>
    );
};
export default UserEmailNotification;